
import { createRoot } from "react-dom/client";

import { HashRouter, Routes, Route } from "react-router";

import { App } from "./app/views/app";

import { Layout } from "./layout/layout";

const container = document.getElementById( 'app' );

const root = createRoot( container );

root.render( 

  <HashRouter>

    <Routes>

      <Route element={ <Layout /> }>
      
        <Route path="/" element={<App />} />

      </Route>

    </Routes>

  </HashRouter>

);
